export default __webpack_public_path__ + "static/media/132.22fca052.png";